import { Switch } from '@thanx/uikit/switch'
import React from 'react'
import DescriptionLink from 'scenes/Cms/components/DescriptionLink'
import { ContentBlockData } from 'slices/appLandingPageTheme/types'
import AddContentButton from './AddContentButton'
import ConfigurationInfo from './ConfigurationInfo'
import Description from './Description'
import Preview from './EditBlock/PersonalizedTextContent/Preview'

type Props = {
  data: ContentBlockData
  onEdit: VoidFunction
}

const PersonalizedTextDescription = ({ data, onEdit }: Props) => {
  if (data.type !== 'personalized_text') return null

  const {
    settings: { text },
    url,
  } = data

  return (
    <>
      <Description type={data.type} />
      <Switch
        condition={Boolean(text)}
        fallback={<AddContentButton onClick={onEdit} />}
      >
        <Preview contentBlock={data} className="mt-m" />
      </Switch>
      <DescriptionLink url={url} className="mt-s" />
      <ConfigurationInfo contentBlock={data} />
    </>
  )
}

export default PersonalizedTextDescription
